import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ============================================================================
// METAMASK & WALLET EXTENSION BYPASS
// Prevents crypto wallet extensions from interfering with the app
// ============================================================================

// Suppress MetaMask and other wallet extension errors ONLY
window.addEventListener('error', (event) => {
  // Only suppress errors from browser extensions, not our app
  if (event.filename && event.filename.includes('chrome-extension://')) {
    event.preventDefault();
    event.stopPropagation();
    console.log('[Alvin\'s Place] Suppressed browser extension error');
    return false;
  }
  // Let all other errors through normally
  return true;
}, true);

// Catch unhandled promise rejections from wallet extensions ONLY
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || event.reason?.toString() || '';
  // Only suppress wallet-specific errors
  if (
    reason.includes('MetaMask') ||
    reason.includes('Failed to connect to MetaMask') ||
    (reason.includes('ethereum') && reason.includes('wallet'))
  ) {
    event.preventDefault();
    console.log('[Alvin\'s Place] Suppressed wallet extension rejection');
    return false;
  }
  // Let all other rejections through
  return true;
}, true);

// ============================================================================
// PWA SERVICE WORKER REGISTRATION
// ============================================================================

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('[Alvin\'s Place] Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.log('[Alvin\'s Place] Service Worker registration failed:', error);
      });
  });
}

// ============================================================================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
